import React from "react";
import ProfilePicture from "web/assets/images/default-group-image.png";
import { CardContainer } from "web/pages/private/CommonPages/MyNetworks/SearchResult/SearchResultStyled";
import Tooltip from "@material-ui/core/Tooltip";
import styled from "styled-components";
import BuildingIcon from "web/assets/svg/BuildingIcon";
import UserIcon from "web/assets/svg/UserIcon";
import LocationIcon from "web/assets/svg/LocationIcon";
import { stateConvert } from "web/components/utils/stateAbbreviation";

const Card = ({ item, isMemberOrGroup, cardCallBack, inviteCallBack, pageLanguageContents }) => {
  const isAlreadyJoined = grpMembers => {
    let userAuthId = localStorage.getItem("authId")
    return grpMembers?.some(item => item.authId === userAuthId)
  }

  return (
    <CardContainer>
      <div className="card-header-top">
        {isMemberOrGroup === 'GROUP' && <p>{pageLanguageContents?.SearchResults[2]?.Group}</p>}
        {isMemberOrGroup === 'MEMBER' && <p>{pageLanguageContents?.SearchResults[3]?.Member}</p>}
        {isMemberOrGroup === 'GROUP' && (item.isPublicPrivate ? <span>Public</span> : '')}
      </div>
      <>
        {isMemberOrGroup === 'GROUP' && (
          <div className="image-wraper group-icon">
            <img
              src={item.profileImage ? process.env.REACT_APP_API_URL + "/user/image/" + item.profileImage : ProfilePicture}
              alt="group-image"
            />
          </div>
        )}
        {isMemberOrGroup === 'MEMBER' && (
          <div className="image-wraper">
            <img
              src={item.profileImage ? process.env.REACT_APP_API_URL + "/user/image/" + item.profileImage : ProfilePicture}
              alt="group-image"
            />
          </div>
        )}
      </>
      <div className="text-detail">
        {isMemberOrGroup === 'GROUP' ? (
          <>
            <Tooltip
              placement="top"
              arrow
              title={item.groupName}
              enterTouchDelay={0}
            >
              <h2 className="group-name">{item.groupName}</h2>
            </Tooltip>
            <h3 className="group-company-name">
              <BuildingIcon style={{ 'width': '15px' }} />
              <Tooltip
                placement="top"
                arrow
                title={item.locationName}
                enterTouchDelay={0}
              >
                <span className="company-name">{item.locationName}</span>
              </Tooltip>
            </h3>
            <h4 className="group-location-name">
              <LocationIcon />
              {item.city}, {item.state}
            </h4>
          </>
        ) : (
          <>
            <Tooltip
              placement="top"
              arrow
              title={item.userName}
              enterTouchDelay={0}
            >
              <h2>{item.userName}</h2>
            </Tooltip>
            <h3 className="group-company-name">
              <BuildingIcon style={{ 'width': '15px' }} />
              <Tooltip
                placement="top"
                arrow
                title={item.locationName}
                enterTouchDelay={0}
              >
                <span className="company-name">{item.locationName}</span>
              </Tooltip>
            </h3>
            <h4 className="group-location-name">
              <LocationIcon />
              {item.city}, {item.state}
            </h4>
          </>
        )}

        {(item.isPublicPrivate && isMemberOrGroup === 'GROUP') && <h6><UserIcon />{item?.memberCount} Members</h6>}

        {item.isPublicPrivate && (
          <Description>
            <Tooltip
              placement="top"
              arrow
              title={item.description}
              enterTouchDelay={0}
            >
              <p>{item.description}</p>
            </Tooltip>
          </Description>
        )}
        <div style={{ minHeight: '47px' }}>
          {isMemberOrGroup === 'MEMBER' ? (
            <>
              {localStorage.getItem("authId") !== item.authId && (
                <button
                  onClick={() => {
                    cardCallBack("InviteMember", item);
                    inviteCallBack(item)
                  }}
                >
                  Invite New Member
                </button>
              )}
            </>
          ) : (
            <>
              {!item.isPublicPrivate && <button className="privateBtnDisabled">Private Group</button>}
              {(item.isPublicPrivate && localStorage.getItem("authId") !== item.authId && !isAlreadyJoined(item.groupMemberDetails)) && (
                <button onClick={() => cardCallBack("requestToJoin", item)}>
                  {pageLanguageContents?.SearchResults[10]?.JoinRequest}
                </button>
              )}
              {localStorage.getItem("authId") === item.authId &&
                <button
                  onClick={() => {
                    cardCallBack("InviteMember", item);
                    inviteCallBack(item)
                  }}
                >
                  Invite New Member
                </button>
              }
            </>
          )}
        </div>
      </div>
    </CardContainer>
  );
};

export default Card;

const Description = styled.div`
  word-break: break-word;
  max-width: 145px;
  width: 100%;
  font-size: 9px;
  line-height: 11px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  a {
    display: block;
  }
`;
